import axiosInstance from "./axiosInstance";

const AUTH_URL = "/auth";

const signUp = async (userData) => {
  try {
    const response = await axiosInstance.post(`${AUTH_URL}/signup`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const signIn = async (userData) => {
  try {
    const response = await axiosInstance.post(`${AUTH_URL}/signin`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { signUp, signIn };
